/*
 *
 *  sagas
 *
 */

import { call, take, put, race, select, all, delay } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_ASSIGNED_EC_LIST,
  ADD_EC_ASSIGN,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadAssignedEcList,
  loadAssignedEcListError,
  loadAssignedEcListSuccess,
  addEcAssignListSuccess,
  addEcAssignListError,
} from "./actions"

import {
  addEcAssignDetails,
  loadAssignedEcDetails,
  loadRecordsMetaData,
} from "./remotes"

import { selectSession } from "../session/selectors"
import { roleIds } from "../../helpers/tools"

function* loadAssignedEcDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_ASSIGNED_EC_LIST),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadAssignedEcList(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadAssignedEcDetails, searchvalue)
        console.log("api result is", result)

        if (result) {
          yield put(loadAssignedEcListSuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadAssignedEcListSuccess([]))
          yield put(loadAssignedEcListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadAssignedEcListSuccess([]))
        yield put(
          loadAssignedEcListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* addEcAssignSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_EC_ASSIGN),
    })
    const { ecAssign } = create || {}
    if (create) {
      // yield call(setSubmitting, true)
      try {
        const result = yield call(addEcAssignDetails, ecAssign)

        if (result) {
          yield put(addEcAssignListSuccess(result.Data))
        } else {
          yield put(addEcAssignListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          addEcAssignListError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      let sessionDetails
      while (true) {
        // eslint-disable-line no-constant-condition
        const sessionInStore = yield select(selectSession())

        const { user = {} } = sessionInStore
        if (user && Object.keys(user).length > 0) {
          sessionDetails = sessionInStore
          break
        }
        yield delay(500)
      }

      let company
      let branch
      if (
        sessionDetails &&
        sessionDetails.user &&
        roleIds.includes(sessionDetails.user.roleId)
      ) {
        company = yield call(loadRecordsMetaData, "company", "post")
        branch = yield call(loadRecordsMetaData, "branch", "post")
      } else {
        company =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.company &&
            sessionDetails.user.company.length > 0 &&
            sessionDetails.user.company.map((_) => _.detail)) ||
          []
        branch =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.branch &&
            sessionDetails.user.branch.length > 0 &&
            sessionDetails.user.branch.map((_) => _.detail)) ||
          []
      }

      const venue_location = yield call(
        loadRecordsMetaData,
        "venue_location",
        "post"
      )
      const event = yield call(
        loadRecordsMetaData,
        "event",
        "post"
      )
      // const priorityStatus = yield call(loadRecordsMetaData, "priority", "post")
      const processStatus = yield call(
        loadRecordsMetaData,
        "process_status",
        "post"
      )
      let permissionMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          (company &&
            company.length > 0 &&
            company.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  { label: c.name, value: c._id, companyId: c.companyId }
                )
              )) ||
          (branch &&
            branch.length > 0 &&
            branch.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],
          processStatusOptions:
          (processStatus &&
            processStatus.data &&
            processStatus.data.length > 0 &&
            processStatus.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p._id,
                    processStatusId: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
        eventOptions:
          (event &&
            event.data &&
            event.data.length > 0 &&
            event.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.eventName,
                    value: c._id,
                    eventCode: c.eventCode,
                    //  companyId: c.companyId
                  }
                )
              )) ||
          [],
        cityOptions:
          (venue_location.data &&
            venue_location.data.length > 0 &&
            venue_location.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          [],

        // priorityOptions:
        //   (priorityStatus &&
        //     priorityStatus.data &&
        //     priorityStatus.data.length > 0 &&
        //     priorityStatus.data
        //       .filter((_) => _.status === 1)
        //       .map((c) =>
        //         Object.assign({}, { label: c.priority, value: c._id })
        //       )) ||
        //   [],
        // // venueNameOptions:
        // (venueName &&
        //   venueName.data &&
        //   venueName.data.length > 0 &&
        //   venueName.data
        //     .filter((_) => _.status === 1)
        //     .map((p) =>
        //       Object.assign(
        //         {},
        //         {
        //           label: p.venueName,
        //           value: p.venueNameId,
        //           colorCode: p.colorCode,
        //         }
        //       )
        //     )) ||
        // [],
      }

      yield put(loadRecordsMetaDataSuccess(permissionMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadAssignedEcDetailsSaga(),
    addEcAssignSaga(),
  ])
}
